import cx from 'classnames'

type Props = {
  text: string
  backgroundColor?: string
  className?: string
}

const Chip = ({
  className,
  text,
  backgroundColor = 'bg-orange-500',
}: Props) => {
  return (
    <span
      className={cx(
        className,
        'text-xs text-white py-1 px-2 rounded whitespace-nowrap',
        backgroundColor
      )}
    >
      {text}
    </span>
  )
}

export default Chip
